import FuseScrollbars from '@fuse/core/FuseScrollbars';
import {
  Collapse,
  List,
  ListItem,
  ListItemIcon,
  ListItemText
} from '@material-ui/core';
import AppBar from '@material-ui/core/AppBar';
import Hidden from '@material-ui/core/Hidden';
import Icon from '@material-ui/core/Icon';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import LanguageSwitcher from 'app/fuse-layouts/shared-components/LanguageSwitcher';
import NavbarFoldedToggleButton from 'app/fuse-layouts/shared-components/NavbarFoldedToggleButton';
import NavbarMobileToggleButton from 'app/fuse-layouts/shared-components/NavbarMobileToggleButton';
import Navigation from 'app/fuse-layouts/shared-components/Navigation';
import UserNavbarHeader from 'app/fuse-layouts/shared-components/UserNavbarHeader';
import { TermsIcon } from 'app/main/components/icons';
import clsx from 'clsx';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  logo: {
    color: theme.palette.text.dynamic
  },
  bg: {
    backgroundColor: 'rgba(0,0,0,.04)'
  },
  itemIcon: {
    minWidth: 0
  },
  content: {
    overflowX: 'hidden',
    overflowY: 'auto',
    '-webkit-overflow-scrolling': 'touch',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '100% 40px, 100% 10px',
    backgroundAttachment: 'local, scroll'
  },
  navigation: {
    paddingTop: 0
  },
  drawerFooter: {
    padding: theme.spacing(1.5),
    borderTop: `solid 1px ${theme.palette.divider}`
  }
}));

function NavbarLayout1(props) {
  const { t } = useTranslation();
  const classes = useStyles();
  const theme = useTheme();
  const user = useSelector(({ auth }) => auth.user);

  const userFromLocalStorage = localStorage.getItem('user');
  const userLS = JSON.parse(userFromLocalStorage);
  const acceptCgu = userLS?.accept_cgu;
  // const acceptCgu = "2024-02-01 00:00:00";
  // add a logic here
  // owner is in the local storage during interpretation, meaning we don't want to show the TOU when an admin is emulating an other user
  const ownerFromLocalStorage = localStorage?.getItem('owner');
  const ownerLS = JSON.parse(ownerFromLocalStorage);
  const hasUserRole = userLS?.role && userLS.role.length > 0;

  const [openSubMenu, setOpenSubMenu] = useState(false);

  const handleSubMenuToggle = () => {
    setOpenSubMenu(!openSubMenu);
  };
  return (
    <div
      className={clsx('flex flex-col overflow-hidden h-full', props.className)}
    >
      <AppBar
        color="primary"
        position="static"
        elevation={0}
        className="flex flex-row justify-end items-center flex-shrink h-64 min-h-64 px-12 navbar-header"
      >
        <Hidden mdDown>
          <NavbarFoldedToggleButton className="w-40 h-40 p-0" />
        </Hidden>

        <Hidden lgUp>
          <NavbarMobileToggleButton className="w-40 h-40 p-0">
            <Icon>
              {theme.direction === 'ltr' ? 'arrow_back' : 'arrow_forward'}
            </Icon>
          </NavbarMobileToggleButton>
        </Hidden>
      </AppBar>

      <UserNavbarHeader />
      <div className={clsx(classes.content, 'flex-grow')}>
        {acceptCgu || ownerLS ? (
          <Navigation
            layout="vertical"
            className={clsx(classes.navigation, 'flex-grow')}
          />
        ) : (
          <List
            style={{
              width: '95%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-end', // Align the list items to the bottom
              height: '100%'
            }}
          >
            <ListItem
              button
              onClick={handleSubMenuToggle}
              style={{ borderRadius: '0 20px 20px 0', overflow: 'hidden' }}
            >
              <TermsIcon
                style={{
                  width: '24px',
                  height: '24px',
                  marginRight: '16px',
                  color: '#00000087'
                }}
              />
              <ListItemText primary={t('term.terms_nav')} />
              <ListItemIcon className={classes.itemIcon}>
                {openSubMenu ? (
                  <ExpandLess style={{ fontSize: 16 }} />
                ) : (
                  <ExpandMore style={{ fontSize: 16 }} />
                )}
              </ListItemIcon>
            </ListItem>
            <Collapse in={openSubMenu} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem
                  button
                  component={Link}
                  to={hasUserRole ? '/terms' : '/conditions'}
                  style={{
                    borderRadius: '0 20px 20px 0',
                    overflow: 'hidden',
                    paddingLeft: '56px'
                  }}
                >
                  <ListItemText primary={t('term.TOU')} />
                </ListItem>
                <ListItem
                  component={Link}
                  to={hasUserRole ? '/privacy-policy' : '/privacy-policy-login'}
                  button
                  style={{
                    borderRadius: '0 20px 20px 0',
                    overflow: 'hidden',
                    paddingLeft: '56px'
                  }}
                >
                  <ListItemText primary={t('term.privacy_policy_title')} />
                </ListItem>
                  <ListItem
                    component={Link}
                    to={hasUserRole ? '/cookies-policy' : '/cookies-policy-login'}
                    button
                    style={{
                      borderRadius: '0 20px 20px 0',
                      overflow: 'hidden',
                      paddingLeft: '56px'
                    }}
                  >
                    <ListItemText primary={t('term.cookies_policy')} />
                  </ListItem>
              </List>
            </Collapse>
          </List>
        )}
      </div>

      <div className={clsx(classes.drawerFooter, 'drawerFooter')}>
        <LanguageSwitcher />
      </div>
    </div>
  );
}

export default React.memo(NavbarLayout1);
